import { render, staticRenderFns } from "./bills-receivable.vue?vue&type=template&id=70997724&scoped=true"
import script from "./bills-receivable.vue?vue&type=script&lang=js"
export * from "./bills-receivable.vue?vue&type=script&lang=js"
import style0 from "./bills-receivable.vue?vue&type=style&index=0&id=70997724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70997724",
  null
  
)

export default component.exports